import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'nationwideSite',
		component: () => import('@/views/site/nationwide'),
	},
	{
		path: '/guizhou-driver-admin', //大区
		name: 'guiZhouDriveAdmin',
		component: () => import('@/views/guiZhouDriveAdmin'),
		children: [],
	},
	{
		path: '/superMap',
		name: 'superMap',
		component: () => import('@/components/superMap.vue'),
	},
	{
		//视频实时监控
		path: '/livePage',
		name: 'livePage',
		component: () => import('@/views/livePage.vue'),
	},
	{
		path: '/Layout',
		name: 'Layout',
		component: () => import('@/views/layout.vue'),
		children: [
			{
				path: '/nationwideSite', //全国-站点
				name: 'nationwideSite',
				component: () => import('@/views/site/nationwide'),
				children: [],
			},
			{
				path: '/nationwideSite2', //全国-站点-测试用
				name: 'nationwideSite2',
				component: () => import('@/views/site/nationwide2'),
				children: [],
			},
			{
				path: '/singleSite', //单个-站点
				name: 'singleSite',
				component: () => import('@/views/site/singleSite'),
				children: [],
			},
			{
				path: '/nationwideLeft', //全国-左边
				name: 'nationwideLeft',
				component: () => import('@/views/operate/nationwide'),
				children: [],
			},
			{
				path: '/nationwideRight', //全国-左边
				name: 'nationwideRight',
				component: () => import('@/views/operate/nationwideRight'),
				children: [],
			},
			{
				path: '/batteryHolder', //电池仓
				name: 'batteryHolder',
				component: () => import('@/views/site/batteryHolder'),
				children: [],
			},
			{
				path: '/batteryBox', //电池箱
				name: 'batteryBox',
				component: () => import('@/views/site/batteryBox'),
				children: [],
			},
			{
				path: '/batteryBag', //电池包
				name: 'batteryBag',
				component: () => import('@/views/site/batteryBag'),
				children: [],
			},
			{
				path: '/district', //大区
				name: 'district',
				component: () => import('@/views/site/district'),
				children: [],
			},
		],
	},
	{
		path: '/pcLayout',
		name: 'pcLayout',
		component: () => import('@/views/pcLayout.vue'),
		children: [
			{
				path: '/pcNationwideSite',
				name: 'pcNationwideSite',
				component: () => import('@/views/pcSite/nationwide'),
			},
			{
				path: '/pcsingleSite',
				name: 'pcsingleSite',
				component: () => import('@/views/pcSite/singleSite'),
			},
			{
				path: '/pcbatteryHolder', //电池仓
				name: 'pcbatteryHolder',
				component: () => import('@/views/pcSite/batteryHolder'),
				children: [],
			},
			{
				path: '/pcbatteryBox', //电池箱
				name: 'pcbatteryBox',
				component: () => import('@/views/pcSite/batteryBox'),
				children: [],
			},
			{
				path: '/pcdistrict', //大区
				name: 'pcdistrict',
				component: () => import('@/views/pcSite/district'),
				children: [],
			},
		],
	},
	// {
	// 	path: '/carmap',
	// 	name: 'carmap',
	// 	component: () => import('@/views/carmap.vue'),
	// 	children: []
	// },
	{
		path: '/exposition',
		name: 'exposition',
		component: () => import('@/views/exposition.vue'),
		children: []
	},
	{
		path: '/LEDScreen',
		name: 'LEDScreen',
		component: () => import('@/views/LEDScreen.vue'),
		children: []
	},
	{
		path: '/exposition2th',
		name: 'exposition2th',
		component: () => import('@/views/exposition2th.vue'),
		children: []
	},
	{
		path: '/energyStorage',
		name: 'energyStorage',
		component: () => import('@/views/energyStorage.vue'),
		children: []
	},
	{
		path: '/dummy',
		name: 'dummy',
		component: () => import('@/views/dummy_new.vue'),
		children: []
	},
	{
		path: '/dummy1',
		name: 'dummy1',
		component: () => import('@/views/dummy1.vue'),
		children: []
	},
	// {
	// 	path: '/photovoltaicItem',
	// 	name: 'photovoltaicItem',
	// 	component: () => import('@/views/photovoltaicItem.vue'),
	// 	children: []
	// },
	{
		path: '/photovoltaicStation',
		name: 'photovoltaicStation',
		component: () => import('@/views/photovoltaicStation.vue'),
		children: []
	},
	{
		path: '/vehicleWeb',
		name: 'vehicleWeb',
		component: () => import('@/views/vehicle.vue'),
		children: [
			{
				path: '/vehicleMap',
				name: 'vehicleMap',
				component: () => import('@/views/vehicle/map'),
			},
			{
				path: '/carmap',
				name: 'carmap',
				component: () => import('@/views/carmap'),
			},
			{
				path: '/vehicleProvince',
				name: 'vehicleProvince',
				component: () => import('@/views/vehicle/map'),
			},
			{
				path: '/singleTruck', // 重卡单车
				name: 'singleTruck',
				component: () => import('@/views/vehicle/carmap'),
			},
			{
				path: '/vehicleCity',
				name: 'vehicleCity',
				component: () => import('@/views/vehicle/map'),
			},
			{
				path: '/vehicleControl',
				name: 'vehicleControl',
				component: () => import('@/views/vehicle/map'),
			},
			{
				path: '/vehicleBatteryBox', //电池箱
				name: 'vehicleBatteryBox',
				component: () => import('@/views/vehicle/batteryBox'),
				children: [],
			},
			// {
			// 	path: '/pcsingleSite',
			// 	name: 'pcsingleSite',
			// 	component: () => import('@/views/pcSite/singleSite'),
			// },
			// {
			// 	path: '/pcbatteryHolder', //电池仓
			// 	name: 'pcbatteryHolder',
			// 	component: () => import('@/views/pcSite/batteryHolder'),
			// 	children: [],
			// },
			// {
			// 	path: '/pcdistrict', //大区
			// 	name: 'pcdistrict',
			// 	component: () => import('@/views/pcSite/district'),
			// 	children: [],
			// },
		]
	},
	{
		path: '/vehicleWebYM',
		name: 'vehicleWebYM',
		component: () => import('@/views/vehicle.vue'),
		children: [
			{
				path: '/vehicleMapYM',
				name: 'vehicleMapYM',
				component: () => import('@/views/vehicle/map'),
			},
			{
				path: '/carmapYM',
				name: 'carmapYM',
				component: () => import('@/views/carmap'),
			},
			{
				path: '/singleTruckYM', // 重卡单车
				name: 'singleTruckYM',
				component: () => import('@/views/vehicle/carmap'),
			},
			{
				path: '/vehicleProvinceYM',
				name: 'vehicleProvinceYM',
				component: () => import('@/views/vehicle/map'),
			},
			{
				path: '/vehicleCityYM',
				name: 'vehicleCityYM',
				component: () => import('@/views/vehicle/map'),
			},
			{
				path: '/vehicleControlYM',
				name: 'vehicleControlYM',
				component: () => import('@/views/vehicle/map'),
			},
			{
				path: '/vehicleBatteryBoxYM', //电池箱
				name: 'vehicleBatteryBoxYM',
				component: () => import('@/views/vehicle/batteryBox'),
				children: [],
			},
		]
	},
	{
		path: '/exposition2',
		name: 'exposition2',
		component: () => import('@/views/pla.vue'),
		children: [
			{
				path: '/photovoltaicItem', // 全国 - 充换电
				name: 'photovoltaicItem',
				component: () => import('@/views/photovoltaicItem.vue'),
			},
		]
	},
	{
		path: '/SmartTransportation',
		name: 'SmartTransportation',
		component: () => import('@/views/Smart.vue'),
		children: [
			{
				path: '/smart1', // 交通拥堵
				name: 'smart1',
				component: () => import('@/views/smart/smart1.vue'),
			},
			{
				path: '/smart2', // 道路养护
				name: 'smart2',
				component: () => import('@/views/smart/smart2.vue'),
			},
			{
				path: '/smart3', // 场站选址
				name: 'smart3',
				component: () => import('@/views/smart/smart3.vue'),
			},
		]
	},
	{
		path: '/exposition2',
		name: 'exposition2',
		component: () => import('@/views/exposition2.vue'),
		children: [
			{
				path: '/changingElectricity', // 全国 - 充换电
				name: 'changingElectricity',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityMerge', // 全国 - 充换电
				name: 'changingElectricityMerge',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityProvince', // 省 - 充换电
				name: 'changingElectricity',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityCity', // 市 - 充换电
				name: 'changingElectricity',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityDistrict', // 区 - 充换电
				name: 'changingElectricity',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/powerStation', // 充换电站
				name: 'powerStation',
				component: () => import('@/views/exposition/powerStation'),
			},
			{
				path: '/batteryCompartment', // 充换电池仓
				name: 'batteryCompartment',
				component: () => import('@/views/exposition/batteryCompartment'),
			},
			{
				path: '/batteryInfo', // 充换电池
				name: 'batteryInfo',
				component: () => import('@/views/exposition/battery'),
			},
			{
				path: '/vehicles', // 全国车辆
				name: 'vehicles',
				component: () => import('@/views/exposition/vehicles'),
			},
			{
				path: '/singleVehicle', // 单车
				name: 'singleVehicle',
				component: () => import('@/views/exposition/singleVehicle'),
			},
			{
				path: '/singlezhongka', // 重卡单车
				name: 'singlezhongka',
				component: () => import('@/views/exposition/singlezhongka'),
			},
      		{
				path: '/newVehiclesProvince', // 省 
				name: 'newVehiclesProvince',
				component: () => import('@/views/exposition/vehicles'),
			},
      		{
				path: '/newVehicleCity', // 市
				name: 'newVehicleCity',
				component: () => import('@/views/exposition/vehicles'),
			},
     		{
				path: '/newVehicleControl', // 区
				name: 'newVehicleControl',
				component: () => import('@/views/exposition/vehicles'),
			},
		]
	},
	{
		path: '/exposition2',
		name: 'exposition2',
		component: () => import('@/views/exposition2.vue'),
		children: [
			{
				path: '/changingElectricity-guizhou', // 全国 - 充换电
				name: 'changingElectricity-guizhou',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityMerge', // 全国 - 充换电
				name: 'changingElectricityMerge',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityProvince', // 省 - 充换电
				name: 'changingElectricity',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityCity', // 市 - 充换电
				name: 'changingElectricity',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityDistrict', // 区 - 充换电
				name: 'changingElectricity',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/powerStation', // 充换电站
				name: 'powerStation',
				component: () => import('@/views/exposition/powerStation'),
			},
			{
				path: '/batteryCompartment', // 充换电池仓
				name: 'batteryCompartment',
				component: () => import('@/views/exposition/batteryCompartment'),
			},
			{
				path: '/batteryInfo', // 充换电池
				name: 'batteryInfo',
				component: () => import('@/views/exposition/battery'),
			},
			{
				path: '/vehicles', // 全国车辆
				name: 'vehicles',
				component: () => import('@/views/exposition/vehicles'),
			},
			{
				path: '/singleVehicle', // 单车
				name: 'singleVehicle',
				component: () => import('@/views/exposition/singleVehicle'),
			},
			{
				path: '/singlezhongka', // 重卡单车
				name: 'singlezhongka',
				component: () => import('@/views/exposition/singlezhongka'),
			},
      		{
				path: '/newVehiclesProvince', // 省 
				name: 'newVehiclesProvince',
				component: () => import('@/views/exposition/vehicles'),
			},
      		{
				path: '/newVehicleCity', // 市
				name: 'newVehicleCity',
				component: () => import('@/views/exposition/vehicles'),
			},
     		{
				path: '/newVehicleControl', // 区
				name: 'newVehicleControl',
				component: () => import('@/views/exposition/vehicles'),
			},
			{
				path: '/carBatteryInfo', // 充换电池
				name: 'carBatteryInfo',
				component: () => import('@/views/exposition/battery'),
			},
			{
				path: '/Intelligence',
				name: 'Intelligence',
				component: () => import('@/views/computility/carouselItem/Intelligence'),
				children: []
			},
		]
	},
	{
		path: '/exposition3',
		name: 'exposition3',
		component: () => import('@/views/exposition3.vue'),
		children: [
			{
				path: '/changingElectricity-guizhou', // 全国 - 充换电
				name: 'changingElectricity-guizhou',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityMerge', // 全国 - 充换电
				name: 'changingElectricityMerge',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityProvince', // 省 - 充换电
				name: 'changingElectricity',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityCity', // 市 - 充换电
				name: 'changingElectricity',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/changingElectricityDistrict', // 区 - 充换电
				name: 'changingElectricity',
				component: () => import('@/views/exposition/changingElectricity'),
			},
			{
				path: '/powerStationNew', // 充换电站
				name: 'powerStationNew',
				component: () => import('@/views/exposition/powerStationNew'),
			},
			{
				path: '/batteryCompartment', // 充换电池仓
				name: 'batteryCompartment',
				component: () => import('@/views/exposition/batteryCompartment'),
			},
			{
				path: '/batteryInfo', // 充换电池
				name: 'batteryInfo',
				component: () => import('@/views/exposition/battery'),
			},
			{
				path: '/vehicles', // 全国车辆
				name: 'vehicles',
				component: () => import('@/views/exposition/vehicles'),
			},
			{
				path: '/singleVehicle', // 单车
				name: 'singleVehicle',
				component: () => import('@/views/exposition/singleVehicle'),
			},
			{
				path: '/singlezhongka', // 重卡单车
				name: 'singlezhongka',
				component: () => import('@/views/exposition/singlezhongka'),
			},
	  		{
				path: '/newVehiclesProvince', // 省 
				name: 'newVehiclesProvince',
				component: () => import('@/views/exposition/vehicles'),
			},
	  		{
				path: '/newVehicleCity', // 市
				name: 'newVehicleCity',
				component: () => import('@/views/exposition/vehicles'),
			},
	 		{
				path: '/newVehicleControl', // 区
				name: 'newVehicleControl',
				component: () => import('@/views/exposition/vehicles'),
			},
			{
				path: '/carBatteryInfo', // 充换电池
				name: 'carBatteryInfo',
				component: () => import('@/views/exposition/battery'),
			},
			{
				path: '/Intelligence',
				name: 'Intelligence',
				component: () => import('@/views/computility/carouselItem/Intelligence'),
				children: []
			},
		]
	},
	{
		path: '/energyMuseumBJ',
		name: 'energyMuseumBJ',
		component: () => import('@/views/energyMuseumBJ'),
		children: []
	},
	{
		path: '/computility',
		name: 'computility',
		component: () => import('@/views/computility'),
		children: []
	},
	{
		path: '/xunidianchang',
		name: 'xunidianchang',
		component: () => import('@/views/computility/carouselItem/xunidianchang'),
		children: []
	},
	{
		path: '/xunidianchang3',
		name: 'xunidianchang3',
		component: () => import('@/views/computility/carouselItem/xunidianchang3'),
		children: []
	},
	{
		path: '/xunidianchang2',
		name: 'xunidianchang2',
		component: () => import('@/views/computility/carouselItem/xunidianchang2'),
		children: []
	},
	{
		path: '/monitor',
		name: 'monitor',
		component: () => import('@/views/computility/monitor'),
		children: []
	},
	{
		path: '/monitor2th',
		name: 'monitor2th',
		component: () => import('@/views/computility/monitor2th'),
		children: []
	},
	{
		path: '/monitor2th2',
		name: 'monitor2th2',
		component: () => import('@/views/computility/monitor2th2'),
		children: []
	},
	{
		path: '/computility2th',
		name: 'computility2th',
		component: () => import('@/views/computility/index2th'),
		children: []
	},
	{
		path: '/HashPowerMerging',
		name: 'HashPowerMerging',
		component: () => import('@/views/computility/HashPowerMerging'),
		children: []
	},
	{
		path: '/HashPowerMerging2',
		name: 'HashPowerMerging2',
		component: () => import('@/views/computility/HashPowerMerging2'),
		children: []
	},
	{
		path: '/digitalfactory',
		name: 'digitalfactory',
		component: () => import('@/views/digitalfactory'),
		children: [
			{
			path: '/digitalfactory-home', // 全国 - 充换电
			name: 'digitalfactory-home',
			component: () => import('@/views/digitalfactory/digitalfactoryCom'),
		}
	]
	},
	{
		path: '/chonghuan',
		name: 'chonghuan',
		component: () => import('@/views/chonghuan.vue'),
		children: [
			// {
			// 	path: '/chonghuan-home', // 全国 - 充换电
			// 	name: 'chonghuan-home',
			// 	component: () => import('@/views/chonghuan/home'),
			// },
			// {
			// 	path: '/chonghuan-monitor', // 全国 - 充换电 - 监控
			// 	name: 'chonghuan-monitor',
			// 	component: () => import('@/views/chonghuan/monitor'),
			// },
			{
				path: '/chonghuan-station', // 全国 - 充换电 - 站/桩
				name: 'chonghuan-station',
				component: () => import('@/views/exposition/station'),
			},
		]
	},
	{
		path: '/robat',
		name: 'robat',
		component: () => import('@/views/robat/index.vue'),
	},
	{
		path: '/robat1',
		name: 'robat1',
		component: () => import('@/views/robat1/index.vue'),
	}
]
const router = new VueRouter({
	// mode: "history",
	routes,
})

export default router
